
import { Vue, Component, Prop } from "vue-property-decorator";
import getVisualStyle from "@/entities/VisualStyle";

interface LanguageCommunicationData {
  communication_languages_spoken: string[];
  preferred_language: string;
  interpreter_needed: boolean;
  preferred_communication_style: string;
}

@Component
export default class LanguageCommunication extends Vue {
  @Prop({ required: true }) readonly data!: LanguageCommunicationData;

  getStyle(data): string {
    return this.getVisitStyle(data);
  }
  getVisitStyle(type: string | undefined): string {
    if (!type) return "n/a";
    return (
      getVisualStyle[type] ||
      type
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
    );
  }

}

